module.exports = __webpack_public_path__ + "img/page-06.52a17118.png";